import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-toggle-label',
  templateUrl: './toggle-label.html',
})
export class ToggleLabel {
  alignToggle = input<'CENTER' | 'TOP'>('CENTER');
}
